import { NormalPlans } from './NormalPlans';
export const PricingPlans = () => {
  return <NormalPlans data-sentry-element="NormalPlans" data-sentry-component="PricingPlans" data-sentry-source-file="PricingPlans.tsx" />;
};